export default __webpack_public_path__ + "static/media/phone.inline.1f161207.svg";